import { actionCreator } from 'utils';
import {
    LOAD_REPRINT,
    SET_REPRINT_FILTERS,
    SET_REPRINT_PAGINATION,
    SET_REPRINT_SORT,
    RESET_REPRINT_FILTERS,
    CHECK_ORDER_ITEMS,
    IGNORE_REPRINT,
} from '../types/reprintTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    jobs: null,
    limit: 50,
    offset: 0,
    sort: {
        key: 'created_at',
        type: 'asc',
    },
    calcul: null,
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    filters: {
        customer: '',
        carpetQuality: '',
        size: '',
        expectedEndDate: undefined,
        state: undefined,
        reprint_state: undefined,
        orderId: '',
        orderItemId: '',
        quantity: '',
        designId: '',
    },
    selected: [],
    ignore: {
        loading: null,
        error: false,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case LOAD_REPRINT:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(LOAD_REPRINT, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(LOAD_REPRINT, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_REPRINT_FILTERS:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(SET_REPRINT_FILTERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case SET_REPRINT_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case SET_REPRINT_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case RESET_REPRINT_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case CHECK_ORDER_ITEMS:
        return Object.assign({}, state, {
            selected: action.payload,
        });

    case IGNORE_REPRINT:
        return Object.assign({}, state, {
            ...state,
            reprint: {
                ...state.reprint,
                loading: action.id,
                error: false,
            },
        });

    case actionCreator(IGNORE_REPRINT, 'res'):
        return Object.assign({}, state, {
            ...state,
            reprint: {
                ...state.reprint,
                loading: null,
                error: false,
            },
        });

    case actionCreator(IGNORE_REPRINT, 'err'):
        return Object.assign({}, state, {
            ...state,
            reprint: {
                ...state.reprint,
                loading: null,
                error: true,
            },
        });

    default:
        return state;
    }
}
